// custom typefaces
// import "@fontsource/montserrat/variable.css"
// import "@fontsource/merriweather"
// // normalize CSS across browsers
// import "./src/normalize.css"
// // custom CSS styles
// import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism-okaidia.css"

// Tailwind
import './src/styles/global.css'

require("prismjs/plugins/line-numbers/prism-line-numbers.css")
